import React,{useState} from 'react';
import { MdOutlineReportProblem,MdDoDisturbAlt } from "react-icons/md";
import CustomDialog from '../../../components/CustomDialog';
import { ImCross } from "react-icons/im";

const RejectVoucherDialog = ({open, setOpen, handleSave, isMobile}) => {
    const [amount, setAmount] = useState(0);
    const [remark, setRemark] = useState("");

    const handleClear = () => {
        setAmount(0);
        setRemark("");
    }

    const handleCancel = () => {
        handleClear();
        setOpen(false);
    }

  return (
    <CustomDialog open={open} isMobile={isMobile}>
            <div className='flex justify-center'>
               <MdOutlineReportProblem className='text-2xl text-red-600'/>
               </div>
               <span> Are you sure you want to reject this voucher?</span>
              <div className='flex justify-center items-center gap-4 mt-2 text-[0.875rem]'>
                    <div className='flex items-center gap-2'>
                    <button
                            className='flex items-center px-3 py-1 border border-customTitleColor rounded bg-customGray text-customInk dark:border-customBorder dark:bg-customSurfaceMuted dark:text-customWhite'
                            onClick={() => handleCancel()}
                        >
                            <ImCross className='mr-1' /> Cancel
                        </button>
                    </div>
                    <div className='flex items-center gap-2'>
                      
                        <button
                            onClick={() => handleSave(amount, remark,handleClear)}
                            className='flex items-center px-3 py-1 border border-customFontRed rounded bg-customFontRed text-customBackColor'
                        >
                           <MdDoDisturbAlt className='mr-1'/> Reject
                        </button>
                    </div>
                </div>
    </CustomDialog>
  )
}

export default RejectVoucherDialog;
